/* React Module */
import React, { Component } from "react";

/* External Module */
import { AnimatePresence, motion } from 'framer-motion'

/* Styles */
import styles from './styles.module.scss'

/* Components */
import { ModalActive } from '../MainLayout/Modal'
import ModalContent from './ModalContent'
import { WorkStructure } from "../../../data/work-list";
import { useImageLoaded, LoadingOverlay } from '../../../common/LoadingImage'

interface IReciept {
    items: Array<WorkStructure>
    layoutUniqueId: string
    children?: React.ReactNode
    disabledLayoutId?: boolean
}

class WorkList extends Component<IReciept> {

    constructor(props: IReciept) {
        super(props)
    }

    render() {
        const { items, disabledLayoutId, layoutUniqueId, children } = this.props

        return <>
            <motion.div className={styles.container}>

                { items.map((ctx: WorkStructure, i)=>{
                    let date = {
                        from: new Date(ctx.date.from),
                        to: new Date(ctx.date.to)
                    },
                    dateString: string = date.from.getFullYear() == date.to.getFullYear() ? 
                                date.from.getFullYear().toString() :
                                `${date.from.getFullYear()} - ${date.to.getFullYear()}`
                    return <motion.div
                        key={ctx.id}
                        initial={{ opacity: 0, y: 30, filter: 'blur(8px)' }}
                        whileInView={{
                            opacity: 1, y: 0, filter: 'blur(0px)',
                            transition: {
                                duration: 0.6,
                                delay: Math.min(i, 12) * 0.05,
                                ease: [0.5, 0.025, 0, 1]
                            }
                        }}
                        viewport={{ once: true, amount: 0.15 }}
                        className={styles.item}
                    >
                        <ModalActive layoutId={ctx.id}
                            layoutUniqueId={`modal-${layoutUniqueId}-${ctx.id}`}
                            isDelay={false}
                            modalStyle={{ width: '100%', maxWidth: 1100 }}
                            modalChildren={
                                <ModalContent
                                    id={ctx.id}
                                    title={ctx.title}
                                    tags={ctx.tags}
                                    describe={ctx.describe}
                                    img={ctx.img}
                                    date={dateString}
                                    link={ctx.link}
                                    imageList={ctx.imageList}
                                    color={ctx.color}
                                />
                            }
                        >
                            <motion.div 
                                // layoutId={`modalCard-${ctx.id}`}
                                style={{
                                    backgroundColor: ctx.color
                                }}
                                className={styles.imgContain}
                            >
                                <WorkCardImage src={ctx.img} />
                            </motion.div>
                            <motion.div className={styles.contentInfo}>
                                <motion.p 
                                    // layoutId={`modalTitle-${ctx.id}`}
                                    className={styles.title}>{ctx.title}</motion.p>
                                <motion.p 
                                    // layoutId={`modalDate-${ctx.id}`}
                                >({dateString})</motion.p>
                                
                                <motion.div className={styles.tagList}>
                                    {ctx.tags?.map((tag: string, i: number) => <motion.div key={i} className={styles.tag}>{tag}</motion.div>)}
                                </motion.div>
                            </motion.div>
                            
                        </ModalActive>
                    </motion.div>
                })}
                
            </motion.div>
        </>
    }

}

export default WorkList;

function WorkCardImage({ src }: { src: string }) {
    const loaded = useImageLoaded(src);
    return (
        <>
            <motion.div
                className={styles.subImgBlur}
                style={{
                    backgroundImage: loaded ? `url(${src})` : undefined,
                }}
            />
            <motion.div className={styles.subGradient}></motion.div>
            <motion.img
                className={styles.img}
                src={src}
                style={{ opacity: loaded ? 1 : 0 }}
            />
            <LoadingOverlay show={!loaded} spinnerSize={36} />
        </>
    );
}